module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navigation_sitemap"
  }, [_c('ul', _vm._l((_vm.links), function(link, i) {
    return (link.navigation) ? _c('li', {
      key: i
    }, [_c('router-link', {
      attrs: {
        "to": link.path
      }
    }, [_vm._v(_vm._s(link.name) + "           ")])], 1) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fd85872","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/navigation/navigation.pug
// module id = 588
// module chunks = 1